<template>
  <div class="flex justify-center mt-10">
    <nav
      class="flex fixed w-11/12 justify-between p-1 bg-bgnav z-20 text-center bottom-4 rounded-3xl shadow-md"
      id="nav"
    >
      <div class="text-slate-200 mr-3  mt-1">
        <router-link to="/reportcustomer" class="flex flex-col p-2">
          <font-awesome-icon icon="list-check" class="fa-lg" />
        </router-link>
      </div>
      <div class="text-slate-200 mr-3  mt-1">
        <router-link to="/report" class="flex flex-col p-2">
          <font-awesome-icon icon="fa-solid fa-receipt" class="fa-lg" />
        </router-link>
      </div>
      <div class="text-slate-200 mr-3  mt-1">
        <router-link to="/addcustomer" class="flex flex-col p-2">
          <font-awesome-icon icon="user-plus" class="fa-lg" />
        </router-link>
      </div>
      <div class="text-slate-200 mr-3 mt-1">
        <router-link to="/customer" class="flex flex-col p-2">
          <font-awesome-icon
            icon="fa-solid fa-magnifying-glass"
            class="fa-lg"
          />
        </router-link>
      </div>
      <div class="relative text-slate-200">
        <router-link
          to="/cart"
          class="flex flex-col p-3"
          v-if="!this.$store.state.isRepeatOrder"
        >
          <div
            class="absolute -top-1 -right-2 bg-bgfont rounded-full text-white text-xs px-2 py-1"
            v-if="cartCount > 0"
          >
            {{ cartCount }}
          </div>

          <font-awesome-icon icon="cart-shopping" class="fa-lg" />
          <!-- <span class="text-xs">سبد خرید</span> -->
        </router-link>
        <router-link to="/RepeatFactor" class="flex flex-col p-2" v-else>
          <div
            class="absolute -top-1 -right-2 bg-bgfont rounded-full text-white text-xs px-2 py-1"
            v-if="cartCount > 0"
          >
            {{ cartCount }}
          </div>

          <font-awesome-icon icon="cart-shopping" class="fa-lg" />
          <!-- <span class="text-xs">سبد خرید</span> -->
        </router-link>
      </div>
      <div class="text-slate-200 ml-3">
        <button
          @click="this.$store.dispatch('logout')"
          class="flex flex-col p-3"
        >
          <font-awesome-icon icon="right-from-bracket" class="fa-lg" />
        </button>
      </div>
    </nav>
  </div>
</template>

<script>
export default {
  name: "BottomNavigation",
  components: {},
  data() {
    return {
      hasHistory: false,
    };
  },
  created() {
    console.log(this.$store.state.isRepeatOrder);
  },
  computed: {
    cartCount() {
      return this.$store.state.cart.products.length;
    },
  },
  methods: {},
  watch: {
    $route() {
      this.hasHistory = window.history.length > 1;
    },
  },
};
</script>
<style scoped>
.router-link-active {
  @apply bg-bgbacknav rounded-full  text-slate-200 shadow-sm;
}
</style>
